var styles = {"breakpoint-sm":"(min-width: 768px)","breakpointSm":"(min-width: 768px)","title":"styles_title__3vnhf bold"};

export default styles;
//# sourceMappingURL=styles.css.js.map
